import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import _camelCase from "lodash/camelCase";
var _excluded = ["accessibilityLabel", "children", "className", "classIcon", "disabled", "dynamicSize", "inTransition", "isCookiePreferencesLink", "max", "multiline", "newWindow", "attributes", "onHover", "onClick", "selected", "stopPropagation", "title", "type", "size", "url"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React, { useContext } from 'react';
import classnames from 'classnames';
import { Icon } from "../../Icon/Icon/Icon";
import { Link } from "../Link/Link";
import { ThemeContext } from "../../../context/theme.context";
import Utility from "../../Utility/Utility";
import styles from "./Button.module.scss";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export var buttonTypes = ['link', 'no-style', 'link-quaternary', 'primary', 'secondary', 'banner-trigger', 'destructive', 'simple-banner'];
export var buttonSizes = ['small', 'medium', 'large'];
export var buttonDefaultPropSize = 'large';
export var Button = function Button(_ref) {
  var _ref$accessibilityLab = _ref.accessibilityLabel,
    accessibilityLabel = _ref$accessibilityLab === void 0 ? '' : _ref$accessibilityLab,
    children = _ref.children,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    _ref$classIcon = _ref.classIcon,
    classIcon = _ref$classIcon === void 0 ? '' : _ref$classIcon,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled,
    _ref$dynamicSize = _ref.dynamicSize,
    dynamicSize = _ref$dynamicSize === void 0 ? false : _ref$dynamicSize,
    _ref$inTransition = _ref.inTransition,
    inTransition = _ref$inTransition === void 0 ? false : _ref$inTransition,
    _ref$isCookiePreferen = _ref.isCookiePreferencesLink,
    isCookiePreferencesLink = _ref$isCookiePreferen === void 0 ? false : _ref$isCookiePreferen,
    _ref$max = _ref.max,
    max = _ref$max === void 0 ? false : _ref$max,
    _ref$multiline = _ref.multiline,
    multiline = _ref$multiline === void 0 ? false : _ref$multiline,
    _ref$newWindow = _ref.newWindow,
    newWindow = _ref$newWindow === void 0 ? false : _ref$newWindow,
    _ref$attributes = _ref.attributes,
    attributes = _ref$attributes === void 0 ? {} : _ref$attributes,
    _ref$onHover = _ref.onHover,
    onHover = _ref$onHover === void 0 ? function () {} : _ref$onHover,
    _ref$onClick = _ref.onClick,
    onClickInit = _ref$onClick === void 0 ? function () {} : _ref$onClick,
    _ref$selected = _ref.selected,
    selected = _ref$selected === void 0 ? false : _ref$selected,
    _ref$stopPropagation = _ref.stopPropagation,
    stopPropagation = _ref$stopPropagation === void 0 ? false : _ref$stopPropagation,
    title = _ref.title,
    _ref$type = _ref.type,
    type = _ref$type === void 0 ? 'primary' : _ref$type,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? buttonDefaultPropSize : _ref$size,
    url = _ref.url,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var theme = useContext(ThemeContext);
  var renderedChildren = Utility.dangerousHTML(children);
  var tabIndex = otherProps.tabIndex;
  var onKeyPress = function onKeyPress(event) {
    // To sync with parent. E.g. with react-collapsible lib.
    if (inTransition) {
      return;
    }
    var key = event.key;

    // We need onKeyPress handler because:
    // 1. <button>'s onClick is not fired on pressing enter.
    // 2. <button>'s onClick is fired on pressing space but
    //  was not consistent with how mouse click or pressing
    //  enter works (due to handling these events in contrib
    //  lib react-collabsible). So handling space in onKeyPress
    //  event make it consistent. Also as space triggers
    //  onClick event as well - we need to suppress it in onClick.
    if (key === 'Enter' || key === ' ') {
      onClick(event);
    }
  };
  var onClick = function onClick(event) {
    // To sync with parent. E.g. with react-collapsible lib.
    if (inTransition) {
      return;
    }
    // If prop "url" is set then <Link> renders
    // otherwise <button> renders.
    // Special case when render <button>:
    // in order not to run code twice
    // on click space. See onKeyPress() function.
    if (!url && event.type === 'click' && 'detail' in event && event.detail === 0) {
      return;
    }
    if (stopPropagation) {
      event.stopPropagation();
    }
    if (isCookiePreferencesLink) {
      event.preventDefault();
      if (window && window.dataLayer && window.dataLayer.push) {
        window.dataLayer.push({
          event: 'show_cookie_preferences'
        });
      }
    }
    if (!disabled) {
      onClickInit(event);
    }
  };
  var onHoverChange = function onHoverChange(hover) {
    onHover(hover);
  };
  var getThemeClass = function getThemeClass(theme) {
    return theme === 'darkBackground' ? 'darkBackground' : 'lightBackground';
  };
  var getButtonClassnames = function getButtonClassnames(theme) {
    var typeClass = _camelCase(type);
    var sizeClass = _camelCase(size);
    return classnames(styles.button, className, styles[typeClass], styles[getThemeClass(theme)], styles.v2,
    // @TODO - remove
    disabled && styles.disabled, dynamicSize && styles.dynamicSize, size && styles[sizeClass], max && styles.max, selected && styles.selected, multiline && styles.multiline);
  };
  var renderLinkChildren = function renderLinkChildren(renderedChildren) {
    var renderLinkQuaternary = /*#__PURE__*/_jsxs("span", {
      className: classnames(styles.quaternaryLinkIcon, classIcon, {
        [styles.quaternaryLinkIconMultiline]: multiline
      }),
      children: ["\xA0", /*#__PURE__*/_jsx(Icon, {
        className: styles.icon,
        fill: "CurrentColor",
        width: "12px",
        height: "12px",
        type: "arrow-right-2"
      })]
    });
    if (multiline) {
      return /*#__PURE__*/_jsxs("div", {
        className: styles.linkChildrenContainer,
        children: [/*#__PURE__*/_jsx("div", {
          className: styles.linkChildrenWrapper,
          children: renderedChildren
        }), type === 'link-quaternary' && renderLinkQuaternary]
      });
    } else {
      return /*#__PURE__*/_jsxs(_Fragment, {
        children: [renderedChildren, type === 'link-quaternary' && renderLinkQuaternary]
      });
    }
  };
  if (url || isCookiePreferencesLink) {
    return /*#__PURE__*/_jsx(Link, _objectSpread(_objectSpread({
      stopPropagation: stopPropagation,
      onClick: onClick,
      disabled: disabled,
      onMouseEnter: function onMouseEnter() {
        onHoverChange(true);
      },
      onMouseLeave: function onMouseLeave() {
        onHoverChange(false);
      }
    }, otherProps), {}, {
      tabIndex: tabIndex,
      url: isCookiePreferencesLink ? '<nolink>' : url,
      className: getButtonClassnames(theme),
      target: newWindow ? '_blank' : '',
      title: title,
      accessibilityLabel: accessibilityLabel,
      attributes: attributes,
      children: renderLinkChildren(renderedChildren)
    }));
  }
  return /*#__PURE__*/_jsx("button", _objectSpread(_objectSpread(_objectSpread({
    disabled: disabled,
    onClick: onClick,
    onKeyPress: onKeyPress,
    onMouseEnter: function onMouseEnter() {
      onHoverChange(true);
    },
    onMouseLeave: function onMouseLeave() {
      onHoverChange(false);
    }
  }, otherProps), {}, {
    tabIndex: tabIndex,
    className: getButtonClassnames(theme),
    type: "button",
    "data-e2e-name": "button",
    title: title,
    "aria-label": accessibilityLabel
  }, attributes), {}, {
    children: renderedChildren
  }));
};